import useFetchLeadChannels from 'components/domain/lead/useFetchLeadChannels';
import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { orderBy } from 'utils/arrayUtils';

interface ChannelMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {}

const ChannelMultiSelectField = ({ ...rest }: ChannelMultiSelectFieldProps) => {
  const { data, isLoading } = useFetchLeadChannels();

  const channels = (data?.leadChannels ?? []).map((leadChannel) => {
    return {
      label: leadChannel.bestProfile,
      value: leadChannel.channel,
    };
  });

  const options = orderBy(channels, [{ field: 'label', order: 'asc' }]);

  if (isLoading) return <LoadingPlaceholder />;

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      isSelectAllEnabled
      options={options}
      {...rest}
    />
  );
};

export default ChannelMultiSelectField;
